import React, {useState, useEffect} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useSelector, useDispatch} from 'react-redux';
import {filterStands} from '../../../actions/stands';
import EnhancedTable from '../../common/enhancedTable';
import {standCols} from '../../../utils/colTypes';
import CustomSnackbar from '../../common/customSnackbar';
import CountryDetail from './detail';
import CONSTANTS from '../../../utils/constants';

const company = JSON.parse(localStorage.getItem('company'));
const profile = JSON.parse(localStorage.getItem('profile'));

const getViewPermission = () => {
  const profileId = localStorage.getItem('profileId');
  const validatePermissions = company && company._id === CONSTANTS.TRIVO_COMPANY_ID && CONSTANTS.ADMIN_ROL_ID === profileId;
  if (validatePermissions) {
    return true;
  }
  window.location.href = '/';
  return false;
};

const Stands = (props) => {
  const title = 'Stands';
  const {page, rowsPerPage, order, orderBy, stands, searchText, sending, dataLength, error, message} = useSelector(state => state.stands);
  const [stand, setStand] = useState(null);
  const [isNew, setIsNew] = useState(false);


  const dispatch = useDispatch();

  useEffect(() => {
    getViewPermission();
    dispatch(filterStands(page, rowsPerPage, order, orderBy, searchText));
  }, []);

  const onSearch = (searchedText) => {
    dispatch(filterStands(page, rowsPerPage, order, orderBy, searchedText));
  };

  const onAdd = () => {
    setStand({});
    setIsNew(true);
  };

  const onDetail = (id) => {
    const standLocal = stands.filter(obj => obj.id === id)[0];
    setStand(standLocal);
    setIsNew(false);
  };

  const handleChangeRowsPerPage = (rowsPerPageLocal) => {
    dispatch(filterStands(page, rowsPerPageLocal, order, orderBy, searchText));
  };

  const handleChangePage = (pageLocal) => {
    dispatch(filterStands(pageLocal, rowsPerPage, order, orderBy, searchText));
  };

  const onOrder = (orderLocal, orderByLocal) => {
    dispatch(filterStands(page, rowsPerPage, orderLocal, orderByLocal, searchText));
  };

  const getEditPermissions = () => {
    if (profile) {
      if (profile.permissions.update_profiles) {
        return true;
      }
    }
    return false;
  };

  const getCreatePermission = () => {
    if (profile) {
      if (profile.permissions.create_profiles) {
        return true;
      }
    }
    return false;
  };

  const handleGoBack = () => {
    dispatch(filterStands(page, rowsPerPage, order, orderBy, searchText));
    setStand(null);
    setIsNew(false);
  };

  const renderSnackBar = () => {
    if (message) {
      return (
        <CustomSnackbar
          variant={error !== null ? 'error' : 'success'}
          message={message}
        />
      );
    }
    return null;
  };

  const isLoading = sending;
  const hasEditPermission = getEditPermissions();
  const hasCreatePermission = getCreatePermission();
  const data = {
    rows: stands,
    cols: standCols
  };
  const handlers = {
    onDetail,
    onAdd,
    onSearch,
    onOrder,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  };
  const config = {
    isDragable: false,
    isSelectable: false,
    hasEditPermission,
    hasCreatePermission,
    isFiterable: false,
    searchText: searchText || '',
    order: {
      by: orderBy,
      direction: order
    },
    pagination: {
      current: page,
      rowsPerPage,
      totalItems: dataLength
    },
    filters: {
      is: false
    }
  };
  return (
    isLoading === true ?
      <CircularProgress style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto'}} />
      :
      <div>
        {renderSnackBar()}
        {  
          !stand ?
            <EnhancedTable
              title={title}
              data={data}
              handlers={handlers}
              config={config}
            />
            :
            <CountryDetail
              stand={stand}
              handleGoBack={handleGoBack}
              isLoading={isLoading}
              isNew={isNew}
            />
        }
      </div>
  );
};
  
export default Stands;
